/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ApplicationInsightsPolicyModule
 */

/**
 * @fileoverview
 *     File contains Ajs dependency tokens for Application Insights Policy factories & services.
 * @author Zhiqian Liu
 */

/**
 * Ajs dependency token for ApplicationInsightsPolicy item.
 */
export const APPLICATION_INSIGHTS_POLICY_ITEM_TOKEN = 'ApplicationInsightsPolicyItem';

/**
 * Ajs dependency token for ApplicationInsightsPolicy collection.
 */
export const APPLICATION_INSIGHTS_POLICY_COLLECTION_TOKEN = 'ApplicationInsightsPolicyCollection';

/**
 * Ajs dependency token for ApplicationSamplingConfig config item.
 */
export const APPLICATION_SAMPLING_CONFIG_CONFIG_ITEM = 'ApplicationSamplingConfigConfigItem';

/**
 * Ajs dependency token for ApplicationInsightsParams config item.
 */
export const APPLICATION_INSIGHTS_PARAMS_CONFIG_ITEM = 'ApplicationInsightsParamsConfigItem';
